export const escapeHtml = (text = '') =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

export const escapeAttr = (text = '') => escapeHtml(text).replace(/"/g, '&quot;');
